<script setup lang="tsx">
import { onBeforeMount, ref } from 'vue'
import Multiselect from 'vue-multiselect'
import type { Response, Role, PageRequest, PageResponse, RoleWithUsers } from '@/models/api-generated'
import http from '@/services/http'
import type { RoleFilter } from '@/models/filters-generated'

const props = defineProps<{ class: any }>()
const isLoading = ref(false)
const model = defineModel<Role[] | undefined>({ required: true })
const options = ref<Role[]>([])

onBeforeMount(() => search(''))

async function search(q: string) {
	isLoading.value = true

	const request: PageRequest<RoleFilter> = {
		page: 1,
		limit: 1000000,
		filter: {
			name: q,
			description: '',
			user: [],
		},
	}

	const { data } = await http.post<Response<PageResponse<RoleWithUsers>>>('api/role/list', request)

	options.value = data.data?.items.map((x) => x.role) ?? []

	isLoading.value = false
}
</script>

<template>
	<Multiselect
		placeholder=""
		:class="props.class"
		:multiple="true"
		:show-labels="false"
		:options="options"
		:internal-search="false"
		:preserve-search="true"
		:show-no-results="false"
		:loading="isLoading"
		v-model="model"
		label="name"
		track-by="id"
		@search-change="search"
	>
	</Multiselect>
</template>
